import { useTranslation } from 'react-i18next'
import { queryClient } from '../../state'
import { CheckoutInfo } from '../../types'
import { UseDescription } from './use-description.types'

export const useDescription: UseDescription = () => {
    const checkoutInfo= queryClient.getQueryData<CheckoutInfo>([
        'checkout-info',
    ])

    const { t } = useTranslation()

    let description = checkoutInfo?.payment_link?.description ?? ''

    if (!description && checkoutInfo?.payment_link?.additional_data.order?.items?.length) {
        description = t('View the details and finalize your order')
    }

    return {
        description,
    }
}
